import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OpreatorsMainComponent } from './opreators-main/opreators-main.component';
import { MatMenuModule } from '@angular/material/menu';
import { AddOperatorComponent } from './add-operator/add-operator.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import {MatSelectModule} from '@angular/material/select';
import { EditOpreatorsComponent } from './edit-opreators/edit-opreators.component';
import { ChangePasswordComponent } from './change-password/change-password.component';


@NgModule({
  declarations: [
    OpreatorsMainComponent,
    AddOperatorComponent,
    EditOpreatorsComponent,
    ChangePasswordComponent
  ],
  imports: [
    CommonModule,
    MatMenuModule,
    ReactiveFormsModule,
    FormsModule,
    MatSelectModule,
    MatDialogModule
  ]
})
export class OperatorsModule { }
